import { render } from "./Ballot.vue?vue&type=template&id=45086ba1"
import script from "./Ballot.vue?vue&type=script&lang=js"
export * from "./Ballot.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__